import { Spacing } from '@billy/design-system'
import { css } from '@emotion/core'

export const getFooterCellStyles = () => {
  return css`
    padding: ${Spacing.S32} ${Spacing.S24};
    text-align: right;

    :first-of-type {
      text-align: left;
    }
  `
}
